<template>
  <div class="bonus-pageIdentity-page">
    <atomic-skeletor class="bonus-pageIdentity-page__back-title" />

    <div class="bonus-pageIdentity-page-header">
      <div class="bonus-pageIdentity-page-header__left">
        <atomic-skeletor class="bonus-pageIdentity-page-header__title" />
        <atomic-skeletor class="bonus-pageIdentity-page-header__description" />
        <atomic-skeletor class="bonus-pageIdentity-page-header__btn" />
      </div>

      <atomic-skeletor class="bonus-pageIdentity-page-header__right" />
    </div>

    <div class="bonus-pageIdentity-page-content">
      <atomic-skeletor class="bonus-pageIdentity-page-content__description" />
      <atomic-skeletor class="bonus-pageIdentity-page-content__title" />

      <div class="bonus-pageIdentity-page-content__wrap">
        <atomic-skeletor class="bonus-pageIdentity-page-content__description" :count="4" />
      </div>
    </div>
  </div>
</template>

<style src="~/assets/styles/components/skeleton-preloader/bonus-pageIdentity-page.scss" lang="scss" />
